let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lOBVk")).then(() => parcelRequire('gQLCs'));